import { TranslationKey } from "@/types/translations";

interface AboutMissionProps {
  translate: (key: TranslationKey) => string;
}

const AboutMission = ({ translate }: AboutMissionProps) => (
  <section className="py-16 md:py-20 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6">
          {translate("about.mission.title")}
        </h2>

        <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
          {translate("about.mission.description")}
        </p>
      </div>
    </div>
  </section>
);

export default AboutMission;
